import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Router } from "@angular/router";
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/userService';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-test-manager',
  templateUrl: './test-manager.component.html',
  styleUrls: ['./test-manager.component.css']
})

export class TestManagerComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  userName: string;
  userCanViewResults: boolean;
  userCanRequest: boolean;

  constructor(
    private idle: Idle,
    private vcr: ViewContainerRef,
    private router: Router,
    private toastr: ToastrManager,
    private authService: AuthService,
    private userService: UserService) {

    //this.toastr.setRootViewContainerRef(vcr);
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(6000);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(6000);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      console.log(this.idleState);
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      this.logout();
      this.router.navigate(['login']);
    });

    idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
    idle.onTimeoutWarning.subscribe((countdown: number) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      if (countdown <= 20 && (countdown % 5 === 0)) {
        this.toastr.warningToastr(this.idleState, "**********")
      }
    });
    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    console.log(this.idleState);
    this.timedOut = false;
  }

  ngOnInit() {
    if (!this.authService.IsAuthenticated()) {
      this.authService.authenticate();
    }
    this.userService.getCurrentUser().subscribe(user => {
      this.userCanViewResults = user.CanViewResults;
      this.userCanRequest = user.CanRequest;
      let source = this.authService.getLoginSource();
      this.userName = user.FirstName + ' ' + user.LastName + (source.SourceName == "" ? '' : '(' + source.SourceName + ')'); // source is 
    });
  }

  changeSource(): void {
    this.authService.deleteStoredSource();
    this.router.navigate(['Source']);
  }
  /*
  getApk(): void {
    this.authService.getApk().then(response => {
      this.saveToFileSystem(response)
    });
  }

  private saveToFileSystem(response) {
    //console.log(response);
    const contentDispositionHeader: string = response.headers.get('content-disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1];
    console.log(filename);
    //const blob = new Blob([response.body], { type: 'text/plain' });
    saveAs(response.body, filename);
    //console.log("id = ", id);
    this.router.navigate(['/manage/request-list']);
  }
  */

  logout(): void {
    this.authService.logout();
    this.router.navigate(['login']);
  }
}
